<template>
  <div>
    <div :class="path_arr == 'path_array1' ? '_screen_box_' : 'screen_media_box'">
      <ul class="flex ul1">
        <li :class="category_id == item.id ? 'active1' : ''" v-for="( item, index ) in media_nav" :key="index"
          @click="nav_route(index)">
          {{ item.title }}
        </li>
      </ul>
      <div class="type2 flex">
        <p>热门标签：</p>
        <ul class="flex ul2">
          <li :class="hongren.date_form.tags == -1 ? 'active' : ''" @click="tab('tags', -1)">不限</li>
          <li :class="hongren.date_form.tags == index ? 'active' : ''" v-for="( item, index ) in search.tags_list"
            :key="index" @click="tab('tags', index)">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="type2 flex">
        <p>红人性别：</p>
        <ul class="flex ul2">
          <li :class="hongren.date_form.age == -1 ? 'active' : ''" @click="tab('age', -1)">不限</li>
          <li :class="hongren.date_form.age == index ? 'active' : ''" v-for="( item, index ) in search.age_list"
            :key="index" @click="tab('age', index)">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="type2 flex">
        <p>红人职业：</p>
        <ul class="flex ul2">
          <li :class="hongren.date_form.career == -1 ? 'active' : ''" @click="tab('career', -1)">不限</li>
          <li :class="hongren.date_form.career == index ? 'active' : ''" v-for="( item, index ) in search.career_list"
            :key="index" @click="tab('career', index)">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="type2 flex">
        <p>红人地域：</p>
        <ul class="flex ul2">
          <li :class="hongren.date_form.area == -1 ? 'active' : ''" @click="tab('area', -1)">不限</li>
          <li :class="hongren.date_form.area == index ? 'active' : ''" v-for="( item, index ) in search.area_list"
            :key="index" @click="tab('area', index)">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="type2 flex">
        <p>红人年代：</p>
        <ul class="flex ul2">
          <li :class="hongren.date_form.years == -1 ? 'active' : ''" @click="tab('years', -1)">不限</li>
          <li :class="hongren.date_form.years == index ? 'active' : ''" v-for="( item, index ) in search.years_list"
            :key="index" @click="tab('years', index)">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="type2 flex">
        <p>报价区间：</p>
        <ul class="flex ul2">
          <li :class="hongren.date_form.price_id == -1 ? 'active' : ''" @click="tab('price_id', -1)">不限</li>
          <li :class="hongren.date_form.price_id == index ? 'active' : ''" v-for="( item, index ) in search.price_list"
            :key="index" @click="tab('price_id', index)">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="type3 flex">
        <p>排序：</p>
        <ul class="flex ul2">
          <li @click="screenFn('')"
              :class="hongren.date_form.order == '' && hongren.date_form.sort == '' ? 'active' : ''"
              style="padding: 0.7rem 1rem">
            默认
          </li>
          <li @click="screenFn('member_price')"
              :id="hongren.date_form.order == 'asc' ? 'activeTrue' : hongren.date_form.order == 'desc' ? 'activeFalse' : ''"
              :class="hongren.date_form.order != '' && hongren.date_form.sort != '' ? 'active' : ''">
            价格
          </li>
        </ul>
      </div>
      <div class="type4 flex">
        <p class="type_title_n">红人名称：</p>
        <el-input @keyup.enter.native="screen_confirm" v-model="hongren.date_form.title"
          placeholder="请输入红人名称"></el-input>
        <button class="sf_but" type="primary" @click="screen_confirm">筛选</button>
        <button class="sf_but2" type="primary" @click="reset_screen">重置筛选</button>
        <button v-if="userInfo && hongren.date_form.collect" class="set_menu_show" type="primary" @click="set_collect">
          我的收藏<i style="margin-left: 5px" class="el-icon-close"></i>
        </button>
        <button v-if="userInfo && !hongren.date_form.collect" class="set_menu_none" type="primary" @click="set_collect">
          我的收藏
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'

  export default {
    props: {
      category_id: Number,
      path_arr: String,
    },
    computed: {
      ...mapState(['hongren']),
      ...mapMutations('hongren', ['SET_DATE_FORM']),
    },
    mounted() {
      //读取本地存储中用户的登录状态
      this.userInfo = localStorage.getItem('user_info')
      let path_url_arr = {
        path_array1: ['/user/user_media/red_talent', '/user/user_media/red_talent1', '/user/user_media/red_talent2', '/user/user_media/red_talent3', '/user/user_media/red_talent4', '/user/user_media/red_talent5', '/user/user_media/red_talent6', '/user/user_media/red_talent7', '/user/user_media/red_talent8', '/user/user_media/red_talent9'],
        path_array2: ['/red_talent_index/talent', '/red_talent_index/talent1', '/red_talent_index/talent2', '/red_talent_index/talent3', '/red_talent_index/talent4', '/red_talent_index/talent5', '/red_talent_index/talent6', '/red_talent_index/talent7', '/red_talent_index/talent8', '/red_talent_index/talent9',],
      }

      this.hongren.date_form.category_id = this.$props.category_id
      // 获取媒介分类
      this.curlGet('/api/hongren/info/init').then(res => {
        if (res.data.code) {
          for (const key in res.data.data) {
            // 拿到导航类型
            this.media_nav.push({
              id: res.data.data[key].id,
              title: res.data.data[key].title,
            })
            // 拿到分类
            if (res.data.data[key].id == this.hongren.date_form.category_id) {
              // 热门标签
              if (res.data.data[key].tags_list) {
                this.search.tags_list = res.data.data[key].tags_list
              }
              // 性别
              if (res.data.data[key].age_list) {
                this.search.age_list = res.data.data[key].age_list
              }
              // 职业
              if (res.data.data[key].career_list) {
                this.search.career_list = res.data.data[key].career_list
              }
              // 地区
              if (res.data.data[key].area_list) {
                this.search.area_list = res.data.data[key].area_list
              }
              // 年代
              if (res.data.data[key].years_list) {
                this.search.years_list = res.data.data[key].years_list
              }
              // 报价
              if (res.data.data[key].price_list) {
                this.search.price_list = res.data.data[key].price_list
              }
            }
          }
          path_url_arr[this.path_arr].forEach((item, index) => {
            this.media_nav[index].path_url = item
          })
          this.screen_confirm()
        }
      })
    },
    data() {
      return {
        media_nav: [],
        search: {
          tags_list: [],
          age_list: [],
          career_list: [],
          area_list: [],
          years_list: [],
          price_list: [],
          priceStatus: [{id: 0, name: '默认价格'},{id: 'desc', name: '价格降序'},{id: 'asc', name: '价格升序'}],
        },
        form: {
        },
        userInfo: {}
      }
    },
    methods: {
      tab(index, id) {
        this.$store.commit('SET_DATE_FORM', { index: index, data: id })

        this.screen_confirm()
      },
      spec_tab(item, index) {
        // 重置之后再赋值
        this.hongren.date_form.is_pub_image = 0
        if (index !== -1) {
          this.hongren.date_form[index] = 1
        }
        this.screen_confirm()
      },
      // 价格 电脑权重 移动权重筛选
      screenFn(item) {
        // 赋值给sort类型
        this.hongren.date_form.sort = item
        if (this.hongren.date_form.order == '' || this.hongren.date_form.order == 'desc') {
          this.hongren.date_form.order = 'asc'
        } else if (this.hongren.date_form.order == 'asc') {
          this.hongren.date_form.order = 'desc'
        }
        if (!item) {
          // 如果用户点击的默认 清除order排序状态
          this.hongren.date_form.order = ''
        }

        this.screen_confirm()
      },
      set_collect() {
        if (this.$store.state.hongren.date_form.collect) {
          this.$store.state.hongren.date_form.collect = 0
        } else {
          this.$store.state.hongren.date_form.collect = 1
        }
        this.screen_confirm()
      },
      reset_screen(type) {
        this.$store.commit('RESET_FILL_FORM', {
          category_id: this.$props.category_id,
          tags: -1,
          age: -1,
          career: -1,
          area: -1,
          years: -1,
          price_id: -1,
          collect: 0,
          order: '',
          sort: '',
        })
        if (type !== 3) {
          this.$emit('screen_confirm')
        }
      },
      screen_confirm() {
        this.$emit('screen_confirm')
      },
      nav_route(index) {
        // this.placard.car_list = []
        this.reset_screen(3)
        // 区分类型,如果是跳转路由,如果是2则重置筛选条件
        this.$router.push({
          path: this.media_nav[index].path_url
        })
      }
    },
  }
</script>

<style lang=scss scoped>
  @use '@/scss/user_media';
</style>